import { userInstance } from "../utils/axiosConfig";

const AuthService = {
    SESSION_DURATION: 2 * 60 * 60 * 1000, // 2 heures
    SESSION_TIMESTAMP_KEY: 'session_timestamp',
    USER_KEY: 'user',

    recordActivity: () => {
        localStorage.setItem(AuthService.SESSION_TIMESTAMP_KEY, Date.now().toString());
    },

    isSessionValid: () => {
        const timestampStr = localStorage.getItem(AuthService.SESSION_TIMESTAMP_KEY);
        if (!timestampStr) return false;

        const lastActivity = parseInt(timestampStr);
        const now = Date.now();
        const timeSinceLastActivity = now - lastActivity;

        return timeSinceLastActivity < AuthService.SESSION_DURATION;
    },

    login: async (username, password, language = 'fr') => {
        try {
            const response = await userInstance.post('/login',
                { username, password },
                {
                    headers: {
                        'Accept-Language': language
                    }
                }
            );

            if (response.data) {
                localStorage.setItem(AuthService.USER_KEY, JSON.stringify(response.data));
                AuthService.recordActivity();
            }
            return response.data;
        } catch (error) {
            console.error('Error logging in:', error.response?.data || error.message || error);
            throw error;
        }
    },

    logout: () => {
        localStorage.removeItem(AuthService.USER_KEY);
        localStorage.removeItem(AuthService.SESSION_TIMESTAMP_KEY);
    },

    getCurrentUser: () => {
        try {
            const user = JSON.parse(localStorage.getItem(AuthService.USER_KEY));
            if (!user) return null;

            const sessionValid = AuthService.isSessionValid();
            if (!sessionValid) {
                AuthService.logout();
                return null;
            }
            return user;
        } catch (error) {
            console.error('Error retrieving current user', error);
            return null;
        }
    },

    getToken: () => {
        const user = AuthService.getCurrentUser();
        return user ? user.token : null;
    },

    updateUserData: (userData) => {
        localStorage.setItem(AuthService.USER_KEY, JSON.stringify(userData));
        AuthService.recordActivity();
    },

    // Méthode pour rafraîchir le token si nécessaire
    refreshToken: async () => {
        try {
            const user = AuthService.getCurrentUser();
            if (!user) throw new Error('No user logged in');

            return user.token;
        } catch (error) {
            console.error('Error refreshing token:', error);
            throw error;
        }
    }
};

export default AuthService;